/**
 * Frame Maker dropdown chrome for product variant <select>s.
 * Storefront product forms only. Never loaded on checkout.
 */
(function () {
  if (window.__iutdSelect) return;
  window.__iutdSelect = true;

  var SELECTOR = ".product-variant-picker-block select[data-single-option-selector], .iutd-contact select[data-iutd-select-field]";
  var openMenu = null;

  function selectedLabel(select) {
    var option = select.options[select.selectedIndex];
    return option ? option.textContent.trim() : "";
  }

  function closeMenu() {
    if (!openMenu) return;
    openMenu.remove();
    if (openMenu._btn) openMenu._btn.classList.remove("is-open");
    openMenu = null;
  }

  function placeMenu(btn, menu) {
    var box = btn.getBoundingClientRect();
    var maxH = Math.min(280, window.innerHeight - box.bottom - 12);
    menu.style.top = box.bottom - 1 + "px";
    menu.style.left = box.left + "px";
    menu.style.width = box.width + "px";
    menu.style.maxHeight = Math.max(120, maxH) + "px";
  }

  function openFor(wrap, select, btn) {
    closeMenu();
    var menu = document.createElement("ul");
    menu.className = "iutd-select__menu";
    menu.setAttribute("role", "listbox");
    menu._btn = btn;

    Array.prototype.forEach.call(select.options, function (option) {
      var item = document.createElement("li");
      item.setAttribute("role", "presentation");
      var choice = document.createElement("button");
      choice.type = "button";
      choice.setAttribute("role", "option");
      choice.textContent = option.textContent.trim();
      var on = option.selected;
      choice.setAttribute("aria-selected", on ? "true" : "false");
      if (on) choice.className = "is-on";
      if (option.disabled) choice.disabled = true;
      choice.addEventListener("click", function () {
        select.value = option.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        btn.textContent = option.textContent.trim();
        closeMenu();
      });
      item.appendChild(choice);
      menu.appendChild(item);
    });

    document.body.appendChild(menu);
    btn.classList.add("is-open");
    placeMenu(btn, menu);
    openMenu = menu;

    var on = menu.querySelector("[aria-selected='true']");
    if (on) on.scrollIntoView({ block: "nearest" });
  }

  function enhance(select) {
    if (select.closest("[data-iutd-select]")) return;
    if (select.closest(".iutd-contact") && window.matchMedia("(max-width: 800px)").matches) return;

    var wrap = document.createElement("div");
    wrap.className = "iutd-select";
    wrap.setAttribute("data-iutd-select", "");
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add("iutd-select__native");
    select.setAttribute("tabindex", "-1");
    select.setAttribute("aria-hidden", "true");

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "iutd-select__btn";
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    btn.textContent = selectedLabel(select);
    wrap.insertBefore(btn, select);

    btn.addEventListener("click", function () {
      if (openMenu && openMenu._btn === btn) {
        closeMenu();
        btn.setAttribute("aria-expanded", "false");
        return;
      }
      openFor(wrap, select, btn);
      btn.setAttribute("aria-expanded", "true");
    });

    select.addEventListener("change", function () {
      btn.textContent = selectedLabel(select);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  document.addEventListener("mousedown", function (event) {
    if (!openMenu) return;
    var target = event.target;
    if (openMenu.contains(target) || (openMenu._btn && openMenu._btn.contains(target))) return;
    closeMenu();
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMenu();
  });
  window.addEventListener("resize", closeMenu);
  window.addEventListener("scroll", closeMenu, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
